export default "__VITE_ASSET__BQlC3e5x__"